export default rendererMode => {
    return {
        onClick: (formObj, state, setState) => {

        }
    };
};